import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Recognize } from './components/sections/Recognize';
import { WhatsInside } from './components/sections/WhatsInside';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Creator } from './components/sections/Creator';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
export function App() {
  return <div className="w-full bg-ink-950 font-sans antialiased" data-id="element-0" data-mp="23vuokdaowwv5">
      <MetaPixel data-id="element-1" data-mp="23t8g8bfz6dbv" />
      <Hero data-id="element-2" data-mp="3ijxo6nd1puib" />
      <main data-id="element-3" data-mp="3ikh8gaq64uzi">
        <Problem data-id="element-4" data-mp="3ikqy1x7ax04o" />
        <BeforeAfter data-id="element-5" data-mp="3ij668fcdfvai" />
        <Recognize data-id="element-6" data-mp="3ijpef4c7z5bc" />
        <WhatsInside data-id="element-7" data-mp="3mlj9mx3nbh44" />
        <Bonuses data-id="element-8" data-mp="3ml12v6jcxkhy" />
        <Offer data-id="element-9" data-mp="3mkhmvvd9p66k" />
        <Guarantee data-id="element-10" data-mp="3mjzrt22ccy08" />
        <Testimonials data-id="element-11" data-mp="3mjg7xft4rzjk" />
        <Creator data-id="element-12" data-mp="3rcj6618urx63" />
        <Faq data-id="element-13" data-mp="3rbzn2h7gv2qh" />
        <FinalCta data-id="element-14" data-mp="3rdar8i4tqci4" />
      </main>
      <FloatingCTA data-id="element-15" data-mp="3rd17vdeab3le" />
      <PurchasePopup data-id="element-16" data-mp="5yjsutqtdfe" />
    </div>;
}